import { Routes } from '@angular/router';
import { authGuard } from './shared/guard/auth.guard';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        pathMatch: 'full',
        title: 'MENU.HEADERS.TITLES.HOME.TAB',
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/auth/profile/profile.component').then((m) => m.ProfileComponent),
        title: 'MENU.HEADERS.TITLES.PROFILE.TAB',
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./pages/user/user.component').then((m) => m.UserOverviewComponent),
        title: 'MENU.HEADERS.TITLES.USERS.TITLE',
        children: [
          {
            path: 'overview',
            redirectTo: '/users',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'bulk-upload',
        loadComponent: () =>
          import('./pages/uploaded-file/uploaded-file.component').then(
            (m) => m.UploadedFileOverviewComponent,
          ),
        title: 'MENU.HEADERS.TITLES.BULK_UPLOAD.TITLE',
        children: [
          {
            path: 'overview',
            redirectTo: '/bulk-upload',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'events',
        loadComponent: () =>
          import('./pages/event/event.component').then((m) => m.EventOverviewComponent),
        title: 'MENU.HEADERS.TITLES.EVENTS.TITLE',
        children: [
          {
            path: 'overview',
            redirectTo: '/events',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'biometric-control',
        loadComponent: () =>
          import('./pages/biometric-control/biometric-control.component').then(
            (m) => m.BiometricControlOverviewComponent,
          ),
        title: 'MENU.HEADERS.TITLES.BIOMETRIC_CONTROL.TITLE',
        children: [
          {
            path: 'overview',
            redirectTo: '/biometric-control',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'full-reports',
        loadComponent: () =>
          import('./pages/full-report/full-report.component').then((m) => m.FullReportComponent),
        title: 'MENU.HEADERS.TITLES.FULL_REPORTS.TITLE',
        children: [
          {
            path: 'overview',
            redirectTo: '/full-reports',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'full-report',
        redirectTo: '/full-reports',
        pathMatch: 'full',
      },
    ],
  },
  // auth pages
  {
    path: 'auth',
    canActivate: [authGuard],
    children: [
      {
        path: 'sign-in',
        loadComponent: () =>
          import('./pages/auth/sign-in/sign-in.component').then((m) => m.SignInComponent),
        title: 'MENU.HEADERS.TITLES.SIGN_IN.TITLE',
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/auth/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent,
          ),
        title: 'MENU.HEADERS.TITLES.FORGOT_PASSWORD.TITLE',
      },
      {
        path: 'change-password/:token',
        loadComponent: () =>
          import('./pages/auth/change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent,
          ),
        title: 'MENU.HEADERS.TITLES.CHANGE_PASSWORD.TITLE',
      },
      {
        path: 'logout',
        loadComponent: () =>
          import('./pages/auth/logout/logout.component').then((m) => m.LogoutComponent),
        title: 'MENU.HEADERS.TITLES.LOGOUT.TITLE',
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
    title: 'MENU.HEADERS.TITLES.NOT_FOUND.TAB',
  },
];


